// extracted by mini-css-extract-plugin
module.exports = {"failViewWrapper":"FailView_failViewWrapper__1NNKo","supportPhoneNumber":"FailView_supportPhoneNumber__M7XxO"};